// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PatternMatchDataService } from 'src/app/modules/patternmatch/services/pattern-match-data/pattern-match-data.service';

@NgModule({
  providers: [PatternMatchDataService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PatternMatchModule {}
